import { EMBED_WIDGET_ELEMENT_PREFIX } from '@repo/shared/constants/core/embed-widget-element';

export const EMBED_WIDGET_INTER_FONT_URL = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';

export const EMBED_WIDGET_INTER_400_LATIN_WOFF2 = 'https://fonts.gstatic.com/s/inter/v20/UcC73FwrK3iLTeHuS_nVMrMxCp50SjIa1ZL7W0Q5nw.woff2';

export const EMBED_WIDGET_DEFAULT_FONT_FAMILY_VALUE = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";

export const EMBED_WIDGET_INTER_FONT_LINK_ID = `${EMBED_WIDGET_ELEMENT_PREFIX}-inter-font`;

/** Marks the runtime script the loader injects. Lives in this leaf module so `loader.ts` — a parser-blocking bundle — can tag the script and `getRuntimeBaseUrl` can find it again without either pulling in heavier constants. */
export const EMBED_AGENT_WIDGET_RUNTIME_SCRIPT_ATTR = `data-${EMBED_WIDGET_ELEMENT_PREFIX}-widget`;
